<div class="valueBreakdownFieldPickerSelect">
  <div class="valueBreakdownFieldPickerSelect__inner">
    <header class="valueBreakdownFieldPickerSelect__header">
      {{
      (ppFieldType() === 'list' ? 'list_custom_field' : 'numerical_custom_field') | ppTranslate
      }}
    </header>

    <pp-select
      class="valueBreakdownFieldPickerSelect__input"
      [ppItems]="filteredCustomFields"
      [ppSelectedItem]="filteredCustomFields[selectedFieldIndex]"
      (ppSelectItem)="selectField($event)"
      [ppNoSearchBar]="true"
      [ppDisabled]="filteredCustomFields.length === 0"
      >
      <ng-container selected>
        @if (selectedFieldIndex !== -1) {
          <span
            ppTooltip
            [ppTitle]="filteredCustomFields[selectedFieldIndex]?.label"
            [ppTrimTooltip]="true"
            class="valueBreakdownFieldPickerSelect__value"
            >
            {{ filteredCustomFields[selectedFieldIndex]?.label }}
          </span>
        }

        @if (selectedFieldIndex === -1) {
          <span class="costField__input__placeholder">
            {{ 'select_field' | ppTranslate }}
          </span>
        }
      </ng-container>
    </pp-select>
  </div>
</div>
